import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { clearAdminAccessToken } from 'services/auth/services';

import FBOButton from '../FBOButton/FBOButton';
import { useAuth0 } from '@auth0/auth0-react';
import { disconnectFromUserOrganization } from 'services/user';

export type FBOAppBarCmp = React.FunctionComponent<FBOAppBarComponentProps>;

export interface FBOAppBarComponentProps {}

const FBOAppBar: FBOAppBarCmp = () => {
  const navigate = useNavigate();
  const { loginWithRedirect, user } = useAuth0();

  const hasAdminAccess = user?.adminSupportAccess;

  const logOutRemoteAccessSSO = useCallback(async () => {
    try {
      const firstRemainingOrganizationId = await disconnectFromUserOrganization(
        user?.email,
        user?.org_id
      );
      clearAdminAccessToken();
      if (firstRemainingOrganizationId) {
        await loginWithRedirect({
          authorizationParams: { organizationId: firstRemainingOrganizationId },
        });
      } else {
        navigate('/logout');
      }
    } catch {
      // ignore error
    }
  }, [navigate]);

  const logOutRemoteAccess = useCallback(async () => {
    await logOutRemoteAccessSSO();
  }, []);

  return (
    <Box data-qa="fbo-app-bar">
      {hasAdminAccess ? (
        <FBOButton
          variant="primary"
          color="negative"
          size="large"
          onClick={logOutRemoteAccess}
          data-qa="remote-user-log-out"
          fullWidth
          style={{ marginBottom: '16px' }}
        >
          Log Out of Remote User
        </FBOButton>
      ) : null}
    </Box>
  );
};

export default FBOAppBar;
